import { forwardRef } from 'react';
import Field from './Field';

const Textarea = forwardRef(function Textarea({ label, hint, error, rows = 3, className, ...rest }, ref) {
  return (
    <Field label={label} hint={hint} error={error} className={className}>
      {({ id, describedBy, invalid }) => (
        <textarea ref={ref} id={id} rows={rows} className="ui-input ui-textarea" aria-describedby={describedBy} aria-invalid={invalid || undefined} {...rest} />
      )}
    </Field>
  );
});
export default Textarea;
